var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 81,
    viewBox: "0 0 64 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8874_61240)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4102 41.4943L28.1445 45.3823L14.4692 69.0686L10.5441 60.3148L21.4102 41.4943Z",
    fill: "#079E88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4102 41.4943L14.6758 37.6062L1.00057 61.2924L10.5441 60.3148L21.4102 41.4943Z",
    fill: "#05668D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0156 41.4943L24.2813 45.3823L37.9566 69.0686L41.8816 60.3148L31.0156 41.4943Z",
    fill: "#05668D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0156 41.4943L37.7499 37.6062L51.4252 61.2924L41.8816 60.3148L31.0156 41.4943Z",
    fill: "#079E88"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0053,
    cy: 25.185,
    r: 23.685,
    fill: "url(#paint0_linear_8874_61240)",
    stroke: "#765C00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0062,
    cy: 25.1848,
    r: 18.098,
    fill: "#A88300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8874_61240",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 38,
    height: 38
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9702,
    cy: 27.1173,
    r: 18.1401,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8874_61240)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.0034,
    cy: 25.1853,
    r: 18.1401,
    fill: "#C09525"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1045 12.5649L30.0175 20.3911L37.8437 21.3694L32.4697 27.3955L33.9306 36.0434L26.1045 32.1303L18.2783 36.0434L19.7522 27.3955L14.3652 21.3694L22.1914 20.3911L26.1045 12.5649Z",
    fill: "url(#paint1_linear_8874_61240)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8874_61240",
    x: 0.216502,
    y: 0.216502,
    width: 62.9617,
    height: 80.6046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8874_61240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8874_61240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8874_61240",
    x1: 26.0053,
    y1: 2,
    x2: 26.0053,
    y2: 48.3699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8874_61240",
    x1: 26.1045,
    y1: 12.5649,
    x2: 26.1045,
    y2: 36.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE896"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/GoldMedal.11e15c289e6ca55c296e38f0680964f9.svg";
export { ForwardRef as ReactComponent };